export default function step(text: string) {
	console.log("- %c" + text + ".", "color: #FF0000")
}
